import type { PickObligation } from "../draft/patchPickObligations.ts";

// Curated pick-obligation TERMS (protections + swaps) by league-start season. Pick OWNERSHIP is
// already correct from the real-player data (DraftPick.tid/originalTid); this only overlays the
// terms the source data doesn't carry. Applied at league creation via patchPickObligations.
//
// The 2026 draft is already done, so 2026-league obligations cover the 2027-2033 window. TO
// CURATE from RealGM "Future Draft Picks" pages — see research/fixtures/pick-obligations-2026.json
// for the format and the ~33 traded first-round candidates (MEM<-LAL, OKC<-DEN, BKN<-NYC, ...).
// Curated from RealGM "Future Draft Pick Details" (provided 2026). Scope note: RealGM's data is
// dominated by multi-team conditional webs (most/least-favorable-of-three, cascading swap rights,
// conditional conveyance) that the lean protectedTop/swap model can't represent faithfully — those
// are left for a richer model. Encoded here are the CLEAN top-N protected first-rounders that map
// directly to picks the game already shows as traded (so tid !== originalTid and the reversion
// actually fires). Full RealGM notes live in research/fixtures/realgm-future-picks-2026.md.
export const PICK_OBLIGATIONS: Record<number, PickObligation[]> = {
	2026: [
		// Lakers' 2027 first to Memphis, top-4 protected (converts to a 2nd if it lands there).
		{ originalAbbrev: "LAL", season: 2027, round: 1, protectedTop: 4, rolloverSeasons: [2027] },
		// Mavericks' 2027 first to Charlotte, top-2 protected.
		{ originalAbbrev: "DAL", season: 2027, round: 1, protectedTop: 2, rolloverSeasons: [2027] },
		// Nuggets' first to OKC, top-5 protected in 2027, 2028, 2029.
		{ originalAbbrev: "DEN", season: 2027, round: 1, protectedTop: 5, rolloverSeasons: [2027, 2028, 2029] },
		// Nuggets' next first to OKC, top-5 protected in 2029, 2030 (conditional chain; simplified).
		{ originalAbbrev: "DEN", season: 2029, round: 1, protectedTop: 5, rolloverSeasons: [2029, 2030] },
	],
};
